export class Property {
    constructor (
        public applyURL: string = '',
        public baths: number = null,
        public beds: number = null,
        public city: string = '',
        public id: number = null,
        public lat: number = null,
        public link: string = '',
        public lng: number = null,
        public region: string = '',
        public rent: string = null,
        public special: string = '',
        public sqft: number = null,
        public status: string = '',
        public street: string = '',
        public thumb: string = '',
        public title: string = '',
        public unit_code: string = '',
        public zip: string = '',
        public post_status: string = '',
        public min_rent: string = null,
        public max_rent: string = null,
        public rentValue: number = null,
        public sqftValue: number = null,
        public state: string = ''
    ) { }
}